// extracted by mini-css-extract-plugin
export default {"title":"Index_title__ZYGXc","container":"Index_container__0GWBB","search-icons":"Index_search-icons__SAWev"};